<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">Forts and Roman Strategy</h1>
<p class="subtitle">A New Approach and Interpretation</p>
<p class="subtitle1">featuring five case studies</p>
<p class="subtitle1">from Roman campaigns in Britain</p>
<p class="author">Paul Coby</p>
<div class="img_containert">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?ae24d9ee